import { t } from 'i18next'
import React, { Fragment } from 'react'
import { useColumnSearchQuote } from './hooks/useColumnSearchQuote'
import Navigation from 'Components/Navigation'
import { TableSearchDocuments } from 'Components/TableSearchDocuments/TableSearchDocuments'
import { SearchSalesDocumentsProvider } from 'state/context/SearchSalesDocumentsContext'
import FilterSearchDocuments from 'Components/TableSearchDocuments/FiltersSearchDocuments/FilterSearchDocuments'
import SearchDocumentsNumberedPagination from 'Components/TableSearchDocuments/SearchDocumentsPagination/SearchDocumentsNumberedPagination'
import ModalQuoteCloneAlert from 'Components/ModalQuoteCloneAlert/ModalQuoteCloneAler'
import Loading from 'Components/Loading'
import CustomSnackbar from 'Components/CustomSnackbar'
import { searchQuotes } from 'redux/services/cotizacionServices'
import {
  quoteDocumentsSearchConfig,
  quoteFilterFields,
} from './searchQuoteDocuments.config'

const QuoteFilter = () => (
  <FilterSearchDocuments
    fields={quoteFilterFields}
    statusFilterKey="quote"
    filterButtonTestId="btn-filter-quotes"
    clearButtonTestId="btn-clear-filters-quotes"
  />
)

function SearchQuote() {
  const {
    columns,
    showModalClone,
    setshowModalClone,
    quoteDataClone,
    isLoadingClone,
    setIsLoadingClone,
    isChangingExpiredStatus,
    handlePreCloneQuote,
    checkFinalPrice,
    history,
    snackbarClone,
    setSnackbarClone,
  } = useColumnSearchQuote()

  return (
    <SearchSalesDocumentsProvider
      fetcher={searchQuotes}
      initialFilters={quoteDocumentsSearchConfig.initialFilters}
      buildPayload={quoteDocumentsSearchConfig.buildPayload}>
      <Fragment>
        <Navigation />
        <section
          className="common-search-content"
          data-testid="container-search-quotes">
          <header className="common-search-header">
            <h2>{t('SEARCH_QUOTATION_T.CREATE_OR_SEARCH_QUOTATION_LABEL')}</h2>
          </header>
          <TableSearchDocuments
            columns={columns}
            FilterComponent={QuoteFilter}
            PaginationComponent={SearchDocumentsNumberedPagination}
          />
        </section>
        {(isLoadingClone || isChangingExpiredStatus) && (
          <div style={{ position: 'fixed', inset: 0, zIndex: 1400 }}>
            <Loading full />
          </div>
        )}
        <ModalQuoteCloneAlert
          showModalClone={showModalClone}
          setshowModalClone={setshowModalClone}
          quote={quoteDataClone}
          setIsLoadingClone={setIsLoadingClone}
          checkFinalPrice={checkFinalPrice}
          history={history}
          isSearch
          handlePreCloneQuote={handlePreCloneQuote}
        />
        <CustomSnackbar
          open={snackbarClone.open}
          message={snackbarClone.message}
          severity={snackbarClone.severity}
          onClose={() =>
            setSnackbarClone({ open: false, message: '', severity: '' })
          }
        />
      </Fragment>
    </SearchSalesDocumentsProvider>
  )
}

export default SearchQuote
